<template>
  <div id="page" ref="homePage" class="page">
    <img class="banner" src="@/modules/interview/images/banner.png">
    <process :process-val="processVal" />
    <div v-if="showType == 1" class="main">
      <div class="content-box">
        <div class="result-text"><span class="sand">您的名额将在 <strong>24小时</strong>后过期</span></div>
      </div>
      <div class="content-hint">
        <span class="big">项目随申随审，招完即停止当期报名</span>
        <br>1)费用包含服装、活动物料、场地、导师、执行团队策划及运营成本等
        <br>2)活动期间不安排集体住宿，个人产生的交通、住宿、餐饮等需自行承担
      </div>
      <div class="content-pay">
        <div class="pay-box">
          <div class="pay-item">
            <div class="pay-item-key">总费用</div>
            <div class="pay-item-val">￥{{ payData.goods_price }}</div>
          </div>
          <div v-if="payData.discount_price > 0" class="pay-item">
            <div class="pay-item-key">奖学金</div>
            <div class="pay-item-val">-￥{{ payData.discount_price }}</div>
          </div>
        </div>
        <div v-if="payData.discount_price > 0" class="pay-count">实际支付：<span class="money">￥{{ payData.pay_price }}</span></div>
        <div v-if="payData.instalment && payData.instalment.instalment_number > 0" class="aging-box">
          <div class="aging-title">人工分期</div>
          <van-radio-group v-model="teamVal" icon-size="15px" checked-color="#FF4713" disabled>
            <van-radio v-for="(item, index) in payData.instalment.instalment_pay" :key="index" :name="index" :class="['aging-item', teamVal == index ? 'sel' : '']" :disabled="item.is_pay == 1">
              <template #icon="props">
                <div v-if="item.is_pay == 0" class="img-icon" :class="[props.checked ? 'activeIcon' : 'inactiveIcon']" />
                <div v-else class="img-icon" />
              </template>
              <span class="team">第{{ item.instalment_number }}期</span>
              <span class="aging-money">￥{{ item.pay_price }}</span>
              <span v-if="item.is_pay == 1" class="aging-time">已付清</span>
              <span v-else class="aging-time"><span class="color-red">{{ item.limit_time }}</span>前付清</span>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="pay-agreement" @click="goto(payData.instalment && payData.instalment.instalment_number > 0)">
          <van-checkbox v-model="checked" icon-size="15px" checked-color="#FF4713" disabled>
            <template #icon="props">
              <div class="checked-icon" :class="[props.checked ? 'activeIcon' : 'inactiveIcon']" />
            </template>
            我已阅读并同意
          </van-checkbox>
          <span class="agreement">《北辰青年YESGO行动用户协议》</span>
        </div>
      </div>
      <div class="bottom-slogan" />
      <div class="pay-bottom">
        <div class="pay-bottom-count">
          合计支付 |
          <span v-if="payData.instalment && payData.instalment.instalment_number > 0 && stagesData" class="count-val">￥{{ stagesData.pay_price }}</span>
          <span v-else class="count-val">￥{{ payData.pay_price }}</span>
        </div>
        <div :class="['pay-btn', isPayLoading ? 'gary' : '' ]" @click="isPayLoading ? '' : checkOrder()">{{ isPayLoading ? '订单生成中..' : '马上支付' }}</div>
      </div>
    </div>
    <div v-if="showType == 2" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="result-text overdue">录取名额已过期</div>
        <div class="result-hint overdue"> 很抱歉您的录取名额已过期，<br>感谢您参与YES GO行动的甄选，<br>也感谢您一直以来对北辰青年的支持</div>
      </div>
      <div class="content-introduce">
        <span class="big">重新激活录取名额</span>
        <br>请联系你的面试官
      </div>
      <div class="bottom-slogan" />
    </div>
    <div v-if="showType == 3" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="result-text welcome">欢迎入学</div>
        <div class="result-hint welcome">欢迎加入「YES GO行动」<br>成为我们中的一员！
          <br>以下是你的录取通知书</div>
        <img v-if="userAccepted" :src="userAccepted" class="user-accepted" @click="onImagePreview(userAccepted)">
        <div class="save-hint">可长按保存证书</div>
      </div>
      <div class="content-introduce">
        我们为你准备了专属的入学助理
        <br><span class="big"> 请扫码添加北北</span>
        <br>为你办理入学吧！
        <img :src="helperCode" class="helper-code" @click="onImagePreview(helperCode)">
      </div>
      <div class="bottom-slogan" />
      <div v-if="orderId" class="order-id">订单号: {{ orderId }}</div>
    </div>
    <van-popup v-model="showName" :close-on-click-overlay="false">
      <div class="enroll-popup">
        <div class="enroll-box">
          <div class="enroll-title">领取录取通知书</div>
          <div class="enroll-txt">请输入你的姓名<br>领取录取通知书</div>
          <div class="enroll-hint">证书一经生成，不可改名！</div>
          <van-field v-model="name" placeholder="请输入您的姓名" input-align="center" class="enroll-input" />
          <div class="enroll-btn" @click="!isCanvasLoading ? prepareCanvas() : ''">{{ isCanvasLoading ? '生成中..' : '确定' }}</div>
        </div>
      </div>
    </van-popup>
    <!-- 录取通知书 -->
    <canvas id="enrollCanvas" ref="enrollCanvas" :width="canvasEnrollW" :height="canvasEnrollH" style="display: none" />
  </div>
</template>

<script>
import { Button, Checkbox, RadioGroup, Radio, Icon, Dialog, Toast, Field, ImagePreview, Popup } from 'vant'
import process from '../components/process'
import { interviewRecord } from '@/api/interview'
import { orderCreat, checkOrder } from '@/api/apply'
import { getUrlKey, checkWx, base64ToBlob, randomString } from '@/utils/index'
import { getLogin } from '@/utils/auth' // 获取auth参数
import COS from 'cos-js-sdk-v5'
import helperCode from '../images/helper-code.png'

export default {
  name: 'Entrance',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    process
  },
  filters: {},
  data: function() {
    return {
      winH: 0,
      showType: undefined,
      processVal: 3,
      teamVal: '2',
      checked: false,
      payData: {},
      stagesData: null, // 当前分期
      // 支付
      orderId: null,
      isPayLoading: false,
      enroll_id: null,
      // 录取通知书
      showName: false,
      name: null,
      canvasEnrollW: 0,
      canvasEnrollH: 0,
      luquPath: new Image(),
      userAccepted: null,
      helperCode: helperCode,
      isCanvasLoading: false,
      // cos
      bucket: 'crm-1252041857',
      region: 'ap-guangzhou',
      cos: null
    }
  },
  created() {
    const that = this
    this.checked = sessionStorage.getItem('agreementType')
    setTimeout(function() {
      that.winH = document.documentElement.clientHeight || document.body.clientHeight
      that.$refs.homePage.style.minHeight = that.winH + 'px'
    }, 300)
    var type = that.$route.query.showType
    Toast.loading({
      duration: 0,
      forbidClick: true,
      loadingType: 'spinner',
      message: '加载中..'
    })
    that.showType = type
    that.processVal = type === '3' ? 4 : 3
    if (sessionStorage.getItem('userPhone')) {
      this.phone = sessionStorage.getItem('userPhone')
      this.getInterviewRecord()
    } else {
      Dialog.alert({
        title: '温馨提示',
        message: '系统未检测到您的手机号，请前往绑定'
      }).then(() => {
        this.$router.replace('/') // 返回首页
      })
    }
    if (type === '3') {
      console.log('生成录取通知书111')
      // 判断cos库是否有图片(if:微信环境下，并且没有phone)
      var checkImg = new Image()
      var src = (getLogin() && !this.phone) ? 'https://crm-1252041857.file.myqcloud.com/crm-yes-go/userAccepted/interview/' + getLogin() + '_accepted' + '.png'
        : 'https://crm-1252041857.file.myqcloud.com/crm-yes-go/userAccepted/interview/' + this.phone + '_accepted' + '.png'
      checkImg.src = src + '?time=' + new Date().valueOf()
      checkImg.onload = () => {
        that.userAccepted = checkImg.src
      }
      checkImg.onerror = () => {
        that.cos = new COS({
          SecretId: 'AKID4Zu8D6NIn2HKKAwRtBKLBzd66wb6mmz0',
          SecretKey: 'xMisvLbBamZIrHZfbXSahfTBiA547nMo'
        })
        that.showName = true
      }
    }
  },
  methods: {
    getInterviewRecord() {
      var that = this
      interviewRecord({
        open_id: getLogin(),
        user_phone: this.phone
      }).then(res => {
        Toast.clear()
        if (res.data.code === 200 && res.data.data.interviewer) {
          this.payData = res.data.data.pay_info
          this.orderId = res.data.data.pay_info.pay_id
          this.enroll_id = res.data.data.record.enroll_id
          // 学期和城市 塞入缓存，用于支付成功后显示
          sessionStorage.setItem('interview_city', res.data.data.record.yesgo_city)
          sessionStorage.setItem('interview_number', res.data.data.record.yesgo_number)
          if (this.payData.pay_way === 1 || this.payData.pay_way === 3) {
            // 支付已经完成
            that.$router.replace('/entrance?showType=3')
          } else {
            if (res.data.data.pay_info.instalment && res.data.data.pay_info.instalment.instalment_pay.length > 0) {
              const list = res.data.data.pay_info.instalment.instalment_pay
              for (var i = 0; i < list.length; i++) {
                if (list[i].is_pay === 0) { // 这里判断最新未支付的，默认勾选
                  this.teamVal = i
                  this.stagesData = list[i]
                  break
                }
              }
              console.log(this.stagesData)
            }
            console.log('支付信息', res.data.data)
          }
        } else {
          Dialog.alert({
            title: '温馨提示',
            message: '未检测到您到预约资料，请重试'
          }).then(() => {
            that.$router.replace('/') // 返回首页
          })
        }
      })
    },
    checkOrder() {
      // 有分期数据 && 期数 > 0 && 有默认勾选的分期 || 没有分期 && 全款金大等0
      if ((this.payData.instalment && this.payData.instalment.instalment_number > 0 && this.stagesData) || (!this.payData.instalment && this.payData.pay_price > 0)) {
        if (this.checked) {
          var sn = sessionStorage.getItem('interview_pay_order_sn')
          var no = sessionStorage.getItem('interview_pay_trade_no')
          var pay_code = sessionStorage.getItem('interview_pay_trade_code')
          if (sn && no && pay_code) {
            checkOrder({
              order_sn: sn,
              trade_no: no
            }).then(res => {
              if (res.code === 200) {
                Dialog.alert({
                  title: '温馨提示',
                  message: '系统检测到您的订单已支付'
                }).then(() => {
                  this.getInterviewRecord()
                  console.log('已支付')
                })
              } else {
                this.$router.push('/orderPay?order_sn=' + sn + '&trade_no=' + no + '&pay_code=' + pay_code)
              }
            })
          } else {
            this.orderCreat()
          }
        } else {
          Toast('请阅读并同意《北辰青年YESGO行动用户协议》')
        }
      } else {
        Toast('付款金额有误')
      }
    },
    // 创建订单
    orderCreat() {
      // 支付称号回调
      this.isPayLoading = true
      var url = window.location.origin + window.location.pathname + window.location.search + '#/paySucceed?orderId=' + this.order_sn + '&type=' + this.payType
      var pay_code = this.payData.instalment && this.payData.instalment.instalment_number > 0 ? this.stagesData.pay_code : this.payData.pay_code
      orderCreat({
        open_id: getLogin(),
        channel: getUrlKey('income'),
        sign_code: sessionStorage.getItem('sign_code') || randomString(),
        activity_id: 238,
        payway: 1,
        environment: checkWx() ? 2 : 1,
        // phone: this.phone,
        // person: this.person,
        pay_code: this.payData.company_pay_code, // 分公司ID
        notifyUrl: url,
        activity_pay: pay_code,
        enroll_id: this.enroll_id,
        instalment_number: this.payData.instalment && this.payData.instalment.instalment_number > 0 ? this.stagesData.instalment_number : undefined
      }).then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('interview_pay_order_sn', res.data.data.ordersn)
          sessionStorage.setItem('interview_pay_trade_no', res.data.data.paydata.trade_no)
          sessionStorage.setItem('interview_pay_trade_code', pay_code)
          this.$router.push('/orderPay?order_sn=' + res.data.data.ordersn + '&trade_no=' + res.data.data.paydata.trade_no + '&pay_code=' + pay_code)
        } else if (res.data.code === 3241) {
          this.isPayLoading = false
          Toast.fail('该订单已支付，请联系客服')
        } else {
          this.isPayLoading = false
          this.$sentry.captureMessage('entrance', { level: 'error', tags: 'orderCreat', extra: { context: '创建订单失败' }})
          Toast.fail(res.data.data)
        }
      })
    },
    onImagePreview(img) {
      ImagePreview([img])
    },
    prepareCanvas() {
      var that = this
      if (this.name.replace(/(^\s*)|(\s*$)/g, '')) {
        that.isCanvasLoading = true
        that.luquPath.setAttribute('crossOrigin', 'anonymous')
        that.luquPath.src = 'https://crm-1252041857.file.myqcloud.com/crm-yes-go/assets/accepted.jpg' + '?time=' + new Date().valueOf()
        that.luquPath.onload = () => {
          that.createEnrollCanvas()
        }
      } else {
        Toast.fail('请输入姓名')
      }
    },
    // 生成录取通知书
    createEnrollCanvas() {
      console.log('进入')
      const that = this
      const enrollCanvas = this.$refs.enrollCanvas
      const ctx = enrollCanvas.getContext('2d')
      that.canvasEnrollH = this.luquPath.height
      that.canvasEnrollW = this.luquPath.width
      setTimeout(function() {
        ctx.drawImage(that.luquPath, 0, 0, that.canvasEnrollW, that.canvasEnrollH)
        ctx.fillStyle = '#ff3e14'
        ctx.font = 'bold 70px sans-serif'
        ctx.textAlign = 'center'
        ctx.fillText(that.name, 940, 410)
      }, 200)
      setTimeout(function() {
        that.isCanvasLoading = false
        that.showName = false
        var data = enrollCanvas.toDataURL()
        that.userAccepted = data
        var toImg = base64ToBlob(data)
        that.uploadFile(toImg) // 图片路径，上传文件夹名称
      }, 200)
    },
    // 上传图片到服务器
    uploadFile(e) {
      const file = e
      const that = this
      if (!file) return
      let originName = ''
      if (getLogin() && !that.phone) {
        originName = '/crm-yes-go/userAccepted/interview/' + getLogin() + '_accepted' + '.png'
      } else {
        originName = '/crm-yes-go/userAccepted/interview/' + that.phone + '_accepted' + '.png'
      }
      this.cos.sliceUploadFile({
        Bucket: that.bucket,
        Region: that.region,
        Key: originName,
        Body: file
      }, function(err, data) {
        if (data) {
          console.log('上传成功', data.Location)
        } else if (err) {
          alert(err)
        }
      })
    },
    goto(type) {
      // type 1分期协议 2普通协议
      this.$router.push('/agreement?type=' + (type ? '1' : '2'))
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    position: relative;
    width: 375px;
    padding-top: 20px;
    .banner{
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
    }
  }
  .page-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 300px;
    margin: 0 auto;
    padding: 20px 0;
    .tips{
      width: 140px;
      height: 35px;
      background: url("../images/enrol_tips.png") no-repeat;
      background-size: contain;
    }
    .tips-enroll{
      width: 140px;
      height: 35px;
      background: url("../images/enroll_tips.png") no-repeat;
      background-size: contain;
    }
    .logo{
      width: 60px;
      height: 50px;
      background: url("../images/yg_logo.png") no-repeat;
      background-size: contain;
    }
  }
  .main{
    position: relative;
    top: 0;
    z-index: 1;
    width: 340px;
    margin: 0 auto;
    padding-top: 70px;
    padding-bottom: 40px;
    .content-box{
      position: relative;
      border-radius: 15px 15px 0 0;
      background: #fff;
      padding: 10px 25px 20px 25px;
      z-index: 2;
      .result-text{
        text-align: center;
        border-bottom: 1px solid #666;
        color: #ee5030;
        font-weight: bold;
        font-size: 25px;
        line-height: 50px;
        padding-left: 8px;
        padding-top: 10px;
        background: url("../images/icon-sand.png") no-repeat 10px bottom;
        background-size: 60px;
        .sand{
          color: #555;
          display: inline-block;
          line-height: 27px;
          width: 150px;
          font-size: 20px;
          padding-left: 40px;
          strong{
            font-size: 24px;
            color: #ee5030;
            font-weight: bold;
          }
        }
        &.overdue{
          color: #777;
          font-size: 22px;
          padding-left: 0;
          line-height: 45px;
          &:before{
            content: '';
            background: url("../images/icon-symbol.png") no-repeat left center;
            background-size: 20px;
            z-index: 1;
            width: 20px;
            height: 20px;
            position: absolute;
            margin-left: -25px;
            margin-top: 15px;
          }
          &:after{
            content: '';
            background: url("../images/icon-symbol.png") no-repeat right center;
            background-size: 30px;
            z-index: 1;
            width: 30px;
            height: 30px;
            position: absolute;
            margin-left: 5px;
            margin-top: 10px;
          }
          background: none;
        }
        &.welcome{
          &:before{
            content: '';
            background: url("../images/icon-fireworks.png") no-repeat left top;
            background-size: 30px;
            z-index: 1;
            width: 30px;
            height: 30px;
            position: absolute;
            margin-left: -35px;
          }
          &:after{
            content: '';
            background: url("../images/icon-fireworks.png") no-repeat right bottom;
            background-size: 20px;
            z-index: 1;
            width: 20px;
            height: 20px;
            position: absolute;
            margin-left: 5px;
            margin-top: 25px;
          }
          background: none;
        }
      }
      .result-hint{
        padding: 15px 0 5px 0;
        color: #333;
        font-size:16px;
        line-height: 30px;
        text-align: center;
        &.welcome{
          font-size: 18px;
          line-height: 30px;
        }
        &.overdue{
          line-height: 28px;
          font-size: 14px;
        }
      }
    }
    .top-bg{
      border-radius: 0 15px 0 0;
      width: 50%;
      height: 10px;
      margin-left: 50%;
      padding-bottom: 10px;
      position: relative;
      top: 0;
      z-index: 1;
      &:after{
        content: '';
        position: absolute;
        left: -100%;
        top: 0;
        width: 100%;
        height: 100px;
        background: #ee5030;
        z-index: -1;
        border-radius: 15px 0 0 0;
      }
      &:before{
        content: '';
        font-size:0;
        border-style:solid;
        overflow:hidden;
        position:absolute;
        border-width:46px;
        border-color: transparent transparent transparent #ee5030;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
    .content-hint{
      position: relative;
      z-index: 1;
      padding: 10px 25px 20px 25px;
      border-radius: 0 0 15px 15px;
      background: #fff;
      line-height: 22px;
      font-size: 14px;
      color: #999999;
      &:after{
        position: absolute;
        top: 0;
        left: 25px;
        content: '';
        width: 16px;
        height: 2px;
        background: #ee5030;
        z-index: 1;
      }
      .big{
        display: inline-block;
        padding-bottom: 5px;
        color: #333;
        font-weight: bold;
      }
    }
    .content-pay{
      position: relative;
      z-index: 1;
      margin-top: 20px;
      padding: 10px 9px 20px 9px;
      border-radius: 15px 15px 0 15px;
      background: #fff;
      line-height: 22px;
      font-size: 14px;
      color: #000;
      .pay-box{
        border-bottom: 1px solid #000000;
        padding: 6px 0;
        margin: 0 15px;
      }
      .pay-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 0;
      }
      .pay-count{
        text-align: right;
        font-size: 15px;
        padding: 10px 0;
        margin: 0 15px;
        .money{
          color: #FF4713;
          font-size: 17px;
          font-weight: 500;
        }
      }
      .pay-agreement{
        font-size: 11px;
        display: flex;
        align-items: center;
        margin: 12px 15px 0 15px;
        line-height: 20px;
        .agreement{
          color: #FF4713;
        }
        .checked-icon{
          width: 16px;
          height: 16px;
          &.activeIcon{
            background: url("../images/icon-sel.png") no-repeat;
            background-size: 100%;
          }
          &.inactiveIcon{
            border-radius: 50%;
            background: #bbbbbb;
          }
        }
      }
    }
    .pay-bottom{
      z-index: 88;
      display: flex;
      height: 45px;
      position: fixed;
      justify-content: space-between;
      bottom: 0;
      left: 0;
      background: #292929;
      width: 100%;
      line-height: 45px;
      .pay-btn{
        background:#FF4713;
        color: #fff;
        font-size: 15px;
        width: 130px;
        text-align: center;
        &.gary{
          background:#777;
        }
      }
      .pay-bottom-count{
        font-size: 15px;
        padding-left: 20px;
        color: #b9b9b9;
      }
      .count-val{
        color: #fff;
      }
    }
    .aging-box{
      margin: 20px 0;
      background: #eeeeee;
      border-radius: 16px;
      padding: 0 12px 8px 12px;
      font-size: 12px;
      .aging-title{
        position: relative;
        width: 100px;
        height: 25px;
        line-height: 25px;
        background: #FF4713;
        border-radius: 6px;
        color: #fff;
        text-align: center;
        font-size: 12px;
        top: -10px;
      }
      .aging-item{
        padding: 8px 0;
        border-bottom: 1px solid #d2d2d2;
        &.sel{
          .team, .aging-money, .aging-time{
            color: #FF4713;
            font-size: 12px;
            font-weight: bold;
          }
        }
        &:last-child{
          border-bottom: none;
        }
      }
      .team, .aging-time{
        color: #999;
      }
      .aging-money{
        color: #999;
        font-weight: 500;
        margin: 0 10px;
      }
      .img-icon{
        width: 16px;
        height: 16px;
        background: url("../images/icon-finish.png") no-repeat;
        background-size: 100%;
        &.activeIcon{
          background: url("../images/icon-sel.png") no-repeat;
          background-size: 100%;
        }
        &.inactiveIcon{
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #bbbbbb;
        }
      }
    }
    .content-introduce{
      position: relative;
      z-index: 1;
      top: -15px;
      padding: 55px 25px 40px 25px;
      border-radius: 0 0 0 15px;
      background: #fff;
      color: #333;
      line-height: 30px;
      font-size: 16px;
      text-align: center;
      &:after{
        position: absolute;
        top: 40px;
        left: 50%;
        margin-left: -8px;
        content: '';
        width: 16px;
        height: 2px;
        background: #ee5030;
        z-index: 1;
      }
      .big{
        color: #ee5030;
        font-size: 22px;
      }
    }
    .bottom-slogan{
      border-radius: 0 0 15px 0;
      background: #fff;
      width: 50%;
      height: 25px;
      margin-left: 50%;
      padding-bottom: 10px;
      position: relative;
      top: -15px;
      &:before{
        content: '';
        font-size:0;
        border-style:solid;
        overflow:hidden;
        position:absolute;
        border-width:46px;
        border-color: transparent #fff transparent transparent;
        left:-92px;
        bottom:0;
      }
      .slogan-path{
        position: absolute;
        left: -50px;
        top: -15px;
        width: 200px;
        height: 100px;
        background: url("../images/slogan.png") no-repeat left center;
        background-size: 100%;
        z-index: 1;
      }
    }
    .order-id{
      position: absolute;
      width: 100%;
      bottom: 20px;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }
  .user-accepted{
    padding-top: 20px;
  }
  .helper-code{
    width: 130px;
    display: block;
    margin: 20px auto;
  }
  .save-hint{
    text-align: center;
    color: #b7b7b7;
    font-size: 12px;
    padding-top: 5px;
  }
  .enroll-popup{
    width: 250px;
    .enroll-box{
      background: #F4F4F4;
      border-radius: 20px;
      overflow: hidden;
    }
    .enroll-title{
      font-weight: bold;
      color: #FF4713;
      font-size: 24px;
      text-align: center;
      border-bottom: 1px solid #898989;
      padding: 20px 0 10px 0;
      margin: 0 30px 20px 30px;
    }
    .enroll-txt{
      font-size: 14px;
      color: #191919;
      text-align: center;
      line-height: 24px;
    }
    .enroll-hint{
      color: #FF4713;
      font-size: 14px;
      text-align: center;
      line-height: 24px;
    }
    .enroll-input{
      margin: 30px auto;
      width: 180px;
      border-radius: 10px;
      height: 33px;
      line-height: 33px;
      background: #cacaca;
      padding: 0;
    }
    .enroll-btn{
      background: #FF4713;
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 10px 0;
    }
  }
  .color-red{
    color: #FF4713;
    padding-right: 5px;
  }
  .van-popup{
    background: none;
  }
</style>
